// extracted by mini-css-extract-plugin
export default {"container":"ModalHeader--container--d0e59b","title":"ModalHeader--title--24992b","leftAction":"ModalHeader--leftAction--36816b"};